import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let SalesPartner = class SalesPartner extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin) {
    get ecommerceAgencies() {
        return [
            {
                name: 'Shopstitch',
                fbId: 'shopstitchco',
                src: `${S3_ASSETS_BUCKET_URL}/shopstitch.png`,
            },
            {
                name: 'Trading Post',
                fbId: 'yourtradingpost.ph',
                src: `${S3_ASSETS_BUCKET_URL}/trading-post.png`,
            },
            {
                name: 'SwitchUp Tech',
                fbId: 'switchuptechasia',
                src: `${S3_ASSETS_BUCKET_URL}/switch-up.png`,
            },
            {
                name: 'Agilis Group',
                fbId: 'agilisenterprisesolutions',
                src: `${S3_ASSETS_BUCKET_URL}/agilis-group.png`,
            },
            {
                name: 'Bots At Work',
                fbId: 'mybotsatwork',
                src: `${S3_ASSETS_BUCKET_URL}/bots-at-work.png`,
            },
            {
                name: 'Redbox Digital Solutions',
                fbId: 'RedboxDigitalSolutionsLtd',
                src: `${S3_ASSETS_BUCKET_URL}/redbox-digital-solutions.png`,
            },
        ];
    }
    get digitalMarketingAgencies() {
        return [
            {
                name: 'CTRL + B Digital',
                fbId: 'ctrlbdigitalinc',
                src: `${S3_ASSETS_BUCKET_URL}/ctrl-b.png`,
            },
            {
                name: 'Mindworx Multimedia',
                fbId: 'mindworxmultimedia',
                src: `${S3_ASSETS_BUCKET_URL}/mindworkx.png`,
            },
            {
                name: 'Propel Manila',
                fbId: 'propelmanila',
                src: `${S3_ASSETS_BUCKET_URL}/propel-manila.png`,
            },
        ];
    }
    get thumbnailHeight() {
        return this.mdAndUp ? 156 : 105;
    }
    heroBanner() {
        const src = `${S3_ASSETS_BUCKET_URL}/sales-partner-landing-hero-banner.png`;
        if (this.mdAndUp) {
            return { src, height: 422 };
        }
        return { src, height: 270 };
    }
    openSalesPartnerFbPage(fbId) {
        window.open(`https://www.facebook.com/${fbId}`);
    }
    openMailer($event) {
        const email = `mailto:${$event.target.outerText.replace(' ', '')}`;
        window.open(email, '_self');
    }
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
};
SalesPartner = __decorate([
    Component({
        components: {
            TheFooter,
            GetStarted,
        },
    })
], SalesPartner);
export default SalesPartner;
